var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"videoplayer_container"}},_vm._l((_vm.playlist),function(item){return _c('VideoDouob',{key:item.id,ref:item.id,refInFor:true,attrs:{"src":item.video.url,"muted":true},on:{"ended":_vm.onVideoPlayerEnded}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }